var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuisine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54.196,
    viewBox: "0 0 60 54.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cuisine",
    transform: "translate(0 -2.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54984",
    "data-name": "Path 54984",
    d: "M18.35,20.805a1,1,0,1,0,1.414-1.414,2.609,2.609,0,0,1,0-3.684,4.6,4.6,0,0,0,0-6.512,1,1,0,1,0-1.414,1.414,2.6,2.6,0,0,1,0,3.684A4.611,4.611,0,0,0,18.35,20.805Z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54985",
    "data-name": "Path 54985",
    d: "M40.35,20.805a1,1,0,1,0,1.414-1.414,2.609,2.609,0,0,1,0-3.684,4.6,4.6,0,0,0,0-6.512,1,1,0,0,0-1.414,1.414,2.6,2.6,0,0,1,0,3.684A4.611,4.611,0,0,0,40.35,20.805Z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54986",
    "data-name": "Path 54986",
    d: "M29.35,14.805a1,1,0,0,0,1.414-1.414,2.609,2.609,0,0,1,0-3.684,4.6,4.6,0,0,0,0-6.512A1,1,0,1,0,29.35,4.609a2.6,2.6,0,0,1,0,3.684A4.611,4.611,0,0,0,29.35,14.805Z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54987",
    "data-name": "Path 54987",
    d: "M55.624,43.721A26.063,26.063,0,0,0,34.957,22.577,4.6,4.6,0,0,0,35,22.1a5,5,0,0,0-10,0,4.343,4.343,0,0,0,.043.48A26.063,26.063,0,0,0,4.376,43.721C2.286,44.9,0,46.645,0,48.6c0,5.085,15.512,8.5,30,8.5s30-3.415,30-8.5C60,46.645,57.714,44.9,55.624,43.721ZM27.006,22.27c0-.058-.006-.116-.006-.172a3,3,0,1,1,6,0c0,.057,0,.114-.006.172-.047,0-.094-.007-.14-.012-.344-.038-.69-.065-1.038-.089-.128-.009-.255-.022-.383-.029-.474-.026-.951-.041-1.432-.041s-.958.015-1.432.041c-.128.007-.255.02-.383.029-.348.024-.694.052-1.038.089C27.1,22.263,27.053,22.264,27.006,22.27Zm-1.88,4.365a22.171,22.171,0,0,1,4.86-.537H30a1,1,0,1,1,0,2h-.013a20.148,20.148,0,0,0-4.421.488.984.984,0,0,1-.221.024,1,1,0,0,1-.219-1.975ZM19.15,29a1,1,0,1,1,1.019,1.721,20.01,20.01,0,0,0-9.186,13.56A1,1,0,0,1,10,45.1a.914.914,0,0,1-.18-.017,1,1,0,0,1-.805-1.163A22.045,22.045,0,0,1,19.15,29ZM30,55.1c-17.1,0-28-4.269-28-6.5,0-.383.474-1.227,2.064-2.328,0,.057,0,.113-.006.17C4.024,46.988,4,47.54,4,48.1v.788l.767.185A108.252,108.252,0,0,0,30,52.056a108.252,108.252,0,0,0,25.233-2.985L56,48.886V48.1c0-.558-.024-1.109-.058-1.658,0-.057,0-.113-.006-.17C57.526,47.371,58,48.215,58,48.6,58,50.829,47.1,55.1,30,55.1Z",
    fill: "#1890ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuisine);
export default __webpack_public_path__ + "static/media/cuisine.3134b3cd5107314c34d16129beea14c2.svg";
export { ForwardRef as ReactComponent };